import { createAction, handleActions } from 'redux-actions';

/**
 * Action Type 선언 
 */
const SET_CUR_MENU = 'header/SET_CUR_MENU';
const SET_HEADER_TRANSPARENT = 'header/SET_HEADER_TRANSPARENT';
const SET_HEADER_OPEN_MENU = 'header/SET_HEADER_OPEN_MENU';


/**
 * Action 생성 함수 선언 
 * 첫번째 인자 : 액션 타입
 * 두번째 인자 : payload data ( store 에서 사용할 data )
 */
export const setCurMenuAction = createAction(SET_CUR_MENU);
export const setHeaderTransferAction = createAction(SET_HEADER_TRANSPARENT);
export const setOpenMenuAction = createAction(SET_HEADER_OPEN_MENU);

/**
 * 초기값 설정 
 */
const initialState = {
    curMenu: 'main',
    headerTransparent: true,
    openMenu: false
};

const headerReducer = handleActions(
    {
        [SET_CUR_MENU]: (state, { payload: curMenu }) => {
            return {
                ...state,
                curMenu
            }
        },
        [SET_HEADER_TRANSPARENT]: (state, { payload: headerTransparent }) => ({
            ...state,
            headerTransparent
        }),
        [SET_HEADER_OPEN_MENU]: (state, { payload: openMenu }) => ({
            ...state,
            openMenu
        }),

    },
    initialState
);

export default headerReducer;